import Heading from "common/components/Typography/Heading/Heading";
import React, { useEffect, useState } from "react";
import styles from './CargaFacturasFileView.module.scss';
import CargaEstadoCuentaForm from "../../Forms/CargaEstadoCuentaForm/CargaEstadoCuentaForm";
import DataTableWidget from "common/components/DataTableWidget/DataTableWidget";
import { useDispatch } from "react-redux";
import { retrieveCatalogs } from "modules/bussiness_logic/actions/catalogActions";
import { Button } from "react-bootstrap";
import Axios from 'services/BackendApi/BackendApi';
import axios from 'axios';
import { CheckCircle, Trash3 } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import TemporaryFileViewer from "common/components/TemporaryFileViewer/TemporaryFileViewer";
import Modal from 'react-bootstrap/Modal';
import { useSearchParams } from 'react-router-dom';
import SpinnerIcon from 'assets/img/loading'
import Alert from 'react-bootstrap/Alert';
import Swal from "sweetalert2";
import { useParams } from 'react-router-dom'

export default function CargaFacturasFileView(props) {
  var prueba = [];
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState({ progress: 0 });
  const [metadata, setMetadata] = useState([]);
  const [Id, setId] = useState(null);
  const [datos, setDatos] = useState(null);
  const navigate = useNavigate();
  const [title, setTitle] = useState(null);
  const [show, setShow] = useState(false);
  const [Cont, setCont] = useState(false);
  const [showpdf, setShowpdf] = useState(null);
  const [isLoading, setisLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [total, setTotal] = useState();
  const { ID } = useParams();

  const handleClose = () => setShow(false);
  const modalClose = () => setOpen(false);
  //const Account = searchParams.get('account');
  const handleShow = (name) => {
    setTitle(name.slice(0, -3));
    setShowpdf(name);
    setShow(true);
  };


  useEffect(() => {
    // const pathname = window.location.pathname;
    // console.log(pathname);
    // let array = pathname.split("/");
    // let id = array[5];
    setId(ID);
    crearReporte(ID);
  }, []);

  async function crearReporte(idReport) {
    const data = await Axios.RecepcionCrearUnzip({ file_id: idReport, type: "FACTURAS" });
    checkReporte(idReport);

  }

  async function checkReporte(id) {
    const data = await Axios.RecepcionCheckUnzip({ report: id });
    // console.log(data);
    if (data.data.result && data.data.query_result.models_1.queryOneModel_1.result.length > 0) {
      let result = data.data.query_result.models_1.queryOneModel_1.result[0];
      if (result.progress < 1.00) {
        setLoading({ progress: result.progress * 100 });
        setTimeout(() => { checkReporte(id); }, 800);
      } else {
        setLoading({ progress: result.progress * 100 });
        getZip(id);
        setisLoading(false);
        // setReporteData({ report: rid, progress: 1.00, ready: true, grant: result.grant });
      }

    }
  }

  async function getZip(id) {
    let excel = await Axios.GetJsonZip({ urlParams: { id } });
    //console.log(excel);
    var tot = 0;
    var count = 0;
    let arreglo = excel.data.data;
    var Contdatos = arreglo.length;
    arreglo.forEach(function (dato, indx) {
      var emp = dato.empresa
      var name = "";
      if (emp.includes("GT")) {
        name = dato.empresa + "-" + dato.no_sap_ora;
      } else {
        name = dato.no_nota;
      }
      tot++;
      var name2 = "Documento";
      var color = "primary"
      if (dato.encontrado == 0) {
        color = "danger";
        count++;
        setShowModal(true);
        name2 = "PDF NO ENCONTRADO";
      }
      var pdf = dato.posicion

      var arreglo = {
        id: dato.llave,
        Empresa: dato.empresa,
        Serie: dato.serie,
        Factura: dato.factura,
        FechaE: dato.fecha_entrega,
        FechaD: dato.fecha_doc,
        Tipo: dato.tipo,
        Sap: dato.sap,
        Cod: dato.cod_solicitante,
        Nit: dato.nit,
        Razon: dato.razon_social,
        Monto: dato.monto,
        Indicador: dato.indicador,
        Pais: dato.pais,
        Autorizacion: dato.autorizacion,
        Area: dato.area,
        Color: color,
        Button: <Button variant={color} onClick={() => handleShow(dato.code + "/" + pdf + "/FC")} >{name2}</Button>
      }
      var meta = {
        id: dato.reception
      };
      setCont(count)
      setTotal(tot);
      setData(preData => [...preData, arreglo])
      setMetadata(preData => [...preData, meta]);
      if (indx === Contdatos - 1) {
        setisLoading(false);
      }
    });
    setOpen(true);
    if (count > 0) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `Hay ${count} registro(s) sin PDF encontrado, por favor revisar lote`,
      });
    } else {
      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: `El lote se cargó exitosamente con ${tot} registro(s)`,
      });
    }
    // setisLoading(false);
    // setMetadata(arrayMeta);
    // setData(array);
  }

  const columns = [
    {
      name: <span>Tipo</span>,
      sortable: true,
      selector: row => row.Tipo
    },
    {
      name: <span>Empresa</span>,
      sortable: true,
      selector: row => row.Empresa
    },
    {
      name: <span>Fecha Entrega</span>,
      sortable: true,
      width: '120px',
      selector: row => row.FechaE
    },
    {
      name: <span>Fecha Documento</span>,
      sortable: true,
      width: '120px',
      selector: row => row.FechaD
    },
    {
      name: <span>Serie</span>,
      sortable: true,
      width: '120px',
      selector: row => row.Serie
    },
    {
      name: <span>Factura</span>,
      sortable: true,
      width: '120px',
      selector: row => row.Factura
    },
    {
      name: <span>Sap</span>,
      sortable: true,
      width: '120px',
      selector: row => row.Sap
    },
    {
      name: <span>Razon</span>,
      sortable: true,
      width: '210px',
      selector: row => row.Razon
    },
    {
      name: <span>Nit</span>,
      sortable: true,
      selector: row => row.Nit
    },
    {
      name: <span>Monto</span>,
      sortable: true,
      selector: row => row.Monto
    },
    {
      name: <span>Indicador</span>,
      sortable: true,
      selector: row => row.Indicador
    },
    {
      name: <span>Pais</span>,
      sortable: true,
      selector: row => row.Pais
    },
    {
      name: <span>Autorizacion</span>,
      sortable: true,
      width: '350px',
      selector: row => row.Autorizacion
    },
    {
      name: <span>Documento</span>,
      width: '150px',
      sortable: true,
      cell: (row) => row.Button
    }
  ];

  const conditionalRowStyles = [
    {
      when: row => row.Color === 'danger',
      style: {
        color: 'red',
      },
    },
  ];

  async function Descartar() {
    // const data = await Axios.DiscardLoteLibro({ urlParams: 1 });
    navigate("/", true);
  }
  async function Entrega() {
    // const data = await Axios.RecepcionCrearNodo(
    //   {
    //     id: metadata[0].id
    //   }
    // );
    // // let res = await Axios.RecepcionEntrega({ id: metadata[0].id, letters: "CR" });
    navigate("/entrega/" + metadata[0].id, true);
  }
  return <>
    {/* <h2>FACTURAS</h2> */}
    {(loading.progress < 100) && <h3>Cargando {Math.round(loading.progress)} %</h3>}


    <div>
      {(showModal) &&
        <Alert variant="danger" >
          <Alert.Heading>Alerta</Alert.Heading>
          <h5>
            Hay {Cont} registro(s) con error, por favor revisar el lote
          </h5>
        </Alert>}
      <DataTableWidget
        title="Recepcion de: Facturas por lote"
        columns={columns}
        data={data}
        conditionalRowStyles={conditionalRowStyles}
      />
    </div>

    {/* <Modal show={open} onHide={modalClose} centered dialogClassName={styles.alerta}>
      {(Cont > 0) ?
        <Modal.Header closeButton className={styles.error}>
          <Modal.Title>Alerta</Modal.Title>
        </Modal.Header>
        :
        <Modal.Header closeButton className={styles.header}>
          <Modal.Title>Carga exitosa</Modal.Title>
        </Modal.Header>
      }
      <Modal.Body className={styles.columna}>
        {(Cont > 0) ?
          <div>
            <h3>Hay {Cont} registro(s) sin PDF encontrado, por favor revisar lote</h3>
          </div>
          :
          <div>
            <h3>El lote se cargó exitosamente con {total} registro(s)</h3>
          </div>}

      </Modal.Body>
    </Modal> */}

    <div className={styles.buttons}>
      <Button variant="danger" onClick={Descartar}><Trash3 /> Descartar</Button>
      <Button variant="primary" onClick={Entrega}><CheckCircle /> Confirmar y enviar</Button>
    </div>

    <Modal show={show} onHide={handleClose} fullscreen style={{ marginLeft: 150 }}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.columna}>
        <TemporaryFileViewer file={Id} pdf={showpdf} />
      </Modal.Body>
    </Modal>
  </>;


}